import React from "react";
import { useSelector } from "react-redux";
import CoursePicture from "../../courseItem/coursePicture/CoursePicture";
import Tooltip from "../../../ui/tooltip/Tooltip";
import NavigateLink from "../../navigateLink/navigateLink";
import EventDates from "./EventDates";
import CourseGalleryItemV2 from "./courseGalleryItemV2/CourseGalleryItemV2";
import gaSectionType from "../../../../enums/gaSectionType";
import classes from "./CourseGalleryItem.module.css";

const CourseGalleryItem = ({ course }) => {

    const { lang } = useSelector(state => state.translate);

    return (
        <NavigateLink link={course?.link} ga={{ section: gaSectionType.sg, sectionValue: course?.domain }}>
            <div className={classes.CourseGalleryItem}>
                <div className={classes.ImageSection}>
                    <CoursePicture picture={course?.picture} courseId={course?.externalId} course={course} />
                    <div className={classes.TitleOverlay}>
                        <div className={classes.CourseTitle}>
                            {course?.name}
                        </div>
                    </div>
                </div>

                <div className={classes.DescriptionSection}>
                    <Tooltip text={course?.description} showTooltip={true} className={classes.CourseDescription}>
                        <div className={classes.CourseDescription}>
                            {course?.description}
                        </div>
                    </Tooltip>
                    <div className={classes.ProviderRow}>
                        <EventDates eventFromDate={course?.calendarEvents?.[0]?.from} eventToDate={course?.calendarEvents?.[0]?.to} />
                        {course?.providerLogo &&
                            <div className={classes.ProviderLogo}>
                                <img src={course?.providerLogo} alt="Provider" className={classes.LogoImage} />
                            </div>
                        }
                    </div>
                </div>
            </div>
            <CourseGalleryItemV2 course={course} />
        </NavigateLink>
    );
};

export default CourseGalleryItem; 